import { render } from "./TouchpointsView.vue?vue&type=template&id=9cfe509a"
import script from "./TouchpointsView.vue?vue&type=script&lang=js"
export * from "./TouchpointsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/playbooks/TouchpointsView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9cfe509a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9cfe509a', __exports__)) {
    api.reload('9cfe509a', __exports__)
  }
  
  module.hot.accept("./TouchpointsView.vue?vue&type=template&id=9cfe509a", () => {
    api.rerender('9cfe509a', render)
  })

}


export default __exports__